var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-project"},[_c('new-project',{attrs:{"target-user-id":_vm.targetUserId,"is-admin":_vm.isAdmin},on:{"validate":function($event){return _vm.addProject($event)},"cancel":function($event){return _vm.goBack()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }